
const investorData = {
  columns: [
    { Header: "name", accessor: "name", width: "20%" },
    { Header: "type", accessor: "type", width: "25%" },
    { Header: "trader payment information", accessor: "paymentInfo" },
    { Header: "status", accessor: "status", width: "7%" },
    { Header: "financial standing", accessor: "standing" },
    { Header: "# of Employees", accessor: "employees" },
    { Header: "office type", accessor: "officeType", width: "20%" },
    { Header: "legal entity type", accessor: "entityType", width: "25%" },
    { Header: "company executives", accessor: "execs" },
    { Header: "date of establishment", accessor: "date", width: "7%" },
    { Header: "address", accessor: "address" },
  ],

  rows: [
    {
      name: "Tiger Global Management",
      type: "5413 ",
      paymentInfo: "true",
      status: "active",
      standing: "$186,775",
      employees: "474,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Julie Ships",
      date: "06/17/2015",
      address: "56 W. 14th St New York, NY"
    },
    {
      name: "New Enterprise Associates",
      type: "6534",
      paymentInfo: "true",
      status: "active",
      standing: "$1,087,358",
      employees: "4,328",
      officeType: "S-CORP",
      entityType: "S-CORP",
      execs: "Reddy Goes",
      date: "01/08/1934",
      address: "4 W. 56th St New York, NY"
    },
    {
      name: "Sequoia Capital",
      type: "76343 ",
      paymentInfo: "true",
      status: "active",
      standing: "$1,987,456",
      employees: "15",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Geo Clims",
      date: "05/13/2004",
      address: "785 W. 13th St New York, NY"
    },
    {
      name: "Kleiner Perkins",
      type: "6785",
      paymentInfo: "true",
      status: "active",
      standing: "$1,350,000",
      employees: "347",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Jun Pines",
      date: "01/08/1934",
      address: "A4 W. 67th St New York, NY"
    },
    {
      name: "Andreessen Horowitz",
      type: "0943",
      paymentInfo: "true",
      status: "active",
      standing: "$1,050,000",
      employees: "74,431",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Mark Redds",
      date: "10/15/2008",
      address: "15 W. 7th Ave New York, NY"
    },
    {
      name: "Accel",
      type: "9639",
      paymentInfo: "true",
      status: "neutral",
      standing: "$5,250",
      employees: "54",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Tanya Ok",
      date: "09/28/2019",
      address: "65 W. 13rd St New York, NY"
    },
    {
      name: "Bessemer Venture Partners",
      type: "3787",
      paymentInfo: "true",
      status: "active",
      standing: "$50,000",
      employees: "78",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Matt Guz",
      date: "11/08/2009",
      address: "234 W. 3rd St New York, NY"
    },
    {
      name: "Institutional Venture Partners",
      type: "6436",
      paymentInfo: "true",
      status: "active",
      standing: "$25,000",
      employees: "8",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Kat Skies",
      date: "07/13/2017",
      address: "34 W. 43rd St New York, NY"
    },
    {
      name: "Deerfield Management",
      type: "9753",
      paymentInfo: "true",
      status: "active",
      standing: "$850,000",
      employees: "74,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Suz Runz",
      date: "09/18/2012",
      address: "134 W. East St New York, NY"
    },
    {
      name: "Founders Fund",
      type: "0961",
      paymentInfo: "true",
      status: "active",
      standing: "$150,000",
      employees: "7,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Annie Payers",
      date: "08/28/2014",
      address: "14 W. 323rd St New York, NY"
    },
    {
      name: "Healthcare Royalty Partners",
      type: "6449",
      paymentInfo: "true",
      status: "active",
      standing: "$350,000",
      employees: "474,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Julie Ships",
      date: "01/08/1934",
      address: "534 W. 73rd St New York, NY"
    },
    {
      name: "Greylock Partners",
      type: "9470",
      paymentInfo: "true",
      status: "active",
      standing: "$750,000",
      employees: "78",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Jang Types",
      date: "02/26/2004",
      address: "4 W. 6th Ave New York, NY"
    },
    {
      name: "Matrix Partners",
      type: "3248",
      paymentInfo: "true",
      status: "active",
      standing: "$350,000",
      employees: "978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Ann Whirlz",
      date: "04/10/1993",
      address: "1234 W. 43rd St New York, NY"
    },
    {
      name: "Tiger Global Management",
      type: "5413 ",
      paymentInfo: "true",
      status: "active",
      standing: "$186,775",
      employees: "474,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Julie Ships",
      date: "06/17/2015",
      address: "56 W. 14th St New York, NY"
    },
    {
      name: "New Enterprise Associates",
      type: "6534",
      paymentInfo: "true",
      status: "active",
      standing: "$1,087,358",
      employees: "4,328",
      officeType: "S-CORP",
      entityType: "S-CORP",
      execs: "Reddy Goes",
      date: "01/08/1934",
      address: "4 W. 56th St New York, NY"
    },
    {
      name: "Sequoia Capital",
      type: "76343 ",
      paymentInfo: "true",
      status: "active",
      standing: "$1,987,456",
      employees: "15",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Geo Clims",
      date: "05/13/2004",
      address: "785 W. 13th St New York, NY"
    },
    {
      name: "Kleiner Perkins",
      type: "6785",
      paymentInfo: "true",
      status: "active",
      standing: "$1,350,000",
      employees: "347",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Jun Pines",
      date: "01/08/1934",
      address: "A4 W. 67th St New York, NY"
    },
    {
      name: "Andreessen Horowitz",
      type: "0943",
      paymentInfo: "true",
      status: "active",
      standing: "$1,050,000",
      employees: "74,431",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Mark Redds",
      date: "10/15/2008",
      address: "15 W. 7th Ave New York, NY"
    },
    {
      name: "Accel",
      type: "9639",
      paymentInfo: "true",
      status: "neutral",
      standing: "$5,250",
      employees: "54",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Tanya Ok",
      date: "09/28/2019",
      address: "65 W. 13rd St New York, NY"
    },
    {
      name: "Bessemer Venture Partners",
      type: "3787",
      paymentInfo: "true",
      status: "active",
      standing: "$50,000",
      employees: "78",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Matt Guz",
      date: "11/08/2009",
      address: "234 W. 3rd St New York, NY"
    },
    {
      name: "Institutional Venture Partners",
      type: "6436",
      paymentInfo: "true",
      status: "active",
      standing: "$25,000",
      employees: "8",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Kat Skies",
      date: "07/13/2017",
      address: "34 W. 43rd St New York, NY"
    },
    {
      name: "Deerfield Management",
      type: "9753",
      paymentInfo: "true",
      status: "active",
      standing: "$850,000",
      employees: "74,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Suz Runz",
      date: "09/18/2012",
      address: "134 W. East St New York, NY"
    },
    {
      name: "Founders Fund",
      type: "0961",
      paymentInfo: "true",
      status: "active",
      standing: "$150,000",
      employees: "7,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Annie Payers",
      date: "08/28/2014",
      address: "14 W. 323rd St New York, NY"
    },
    {
      name: "Healthcare Royalty Partners",
      type: "6449",
      paymentInfo: "true",
      status: "active",
      standing: "$350,000",
      employees: "474,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Julie Ships",
      date: "01/08/1934",
      address: "534 W. 73rd St New York, NY"
    },
    {
      name: "Greylock Partners",
      type: "9470",
      paymentInfo: "true",
      status: "active",
      standing: "$750,000",
      employees: "78",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Jang Types",
      date: "02/26/2004",
      address: "4 W. 6th Ave New York, NY"
    },
    {
      name: "Matrix Partners",
      type: "3248",
      paymentInfo: "true",
      status: "active",
      standing: "$350,000",
      employees: "978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Ann Whirlz",
      date: "04/10/1993",
      address: "1234 W. 43rd St New York, NY"
    },
    {
      name: "Tiger Global Management",
      type: "5413 ",
      paymentInfo: "true",
      status: "active",
      standing: "$186,775",
      employees: "474,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Julie Ships",
      date: "06/17/2015",
      address: "56 W. 14th St New York, NY"
    },
    {
      name: "New Enterprise Associates",
      type: "6534",
      paymentInfo: "true",
      status: "active",
      standing: "$1,087,358",
      employees: "4,328",
      officeType: "S-CORP",
      entityType: "S-CORP",
      execs: "Reddy Goes",
      date: "01/08/1934",
      address: "4 W. 56th St New York, NY"
    },
    {
      name: "Sequoia Capital",
      type: "76343 ",
      paymentInfo: "true",
      status: "active",
      standing: "$1,987,456",
      employees: "15",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Geo Clims",
      date: "05/13/2004",
      address: "785 W. 13th St New York, NY"
    },
    {
      name: "Kleiner Perkins",
      type: "6785",
      paymentInfo: "true",
      status: "active",
      standing: "$1,350,000",
      employees: "347",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Jun Pines",
      date: "01/08/1934",
      address: "A4 W. 67th St New York, NY"
    },
    {
      name: "Andreessen Horowitz",
      type: "0943",
      paymentInfo: "true",
      status: "active",
      standing: "$1,050,000",
      employees: "74,431",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Mark Redds",
      date: "10/15/2008",
      address: "15 W. 7th Ave New York, NY"
    },
    {
      name: "Accel",
      type: "9639",
      paymentInfo: "true",
      status: "neutral",
      standing: "$5,250",
      employees: "54",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Tanya Ok",
      date: "09/28/2019",
      address: "65 W. 13rd St New York, NY"
    },
    {
      name: "Bessemer Venture Partners",
      type: "3787",
      paymentInfo: "true",
      status: "active",
      standing: "$50,000",
      employees: "78",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Matt Guz",
      date: "11/08/2009",
      address: "234 W. 3rd St New York, NY"
    },
    {
      name: "Institutional Venture Partners",
      type: "6436",
      paymentInfo: "true",
      status: "active",
      standing: "$25,000",
      employees: "8",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Kat Skies",
      date: "07/13/2017",
      address: "34 W. 43rd St New York, NY"
    },
    {
      name: "Deerfield Management",
      type: "9753",
      paymentInfo: "true",
      status: "active",
      standing: "$850,000",
      employees: "74,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Suz Runz",
      date: "09/18/2012",
      address: "134 W. East St New York, NY"
    },
    {
      name: "Founders Fund",
      type: "0961",
      paymentInfo: "true",
      status: "active",
      standing: "$150,000",
      employees: "7,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Annie Payers",
      date: "08/28/2014",
      address: "14 W. 323rd St New York, NY"
    },
    {
      name: "Healthcare Royalty Partners",
      type: "6449",
      paymentInfo: "true",
      status: "active",
      standing: "$350,000",
      employees: "474,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Julie Ships",
      date: "01/08/1934",
      address: "534 W. 73rd St New York, NY"
    },
    {
      name: "Greylock Partners",
      type: "9470",
      paymentInfo: "true",
      status: "active",
      standing: "$750,000",
      employees: "78",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Jang Types",
      date: "02/26/2004",
      address: "4 W. 6th Ave New York, NY"
    },
    {
      name: "Matrix Partners",
      type: "3248",
      paymentInfo: "true",
      status: "active",
      standing: "$350,000",
      employees: "978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Ann Whirlz",
      date: "04/10/1993",
      address: "1234 W. 43rd St New York, NY"
    },
  ],
};


export default investorData;
